document.addEventListener('DOMContentLoaded', function() {
  // 'main'要素を取得
  const mainContainer = document.querySelector('main');
  if (mainContainer) {
    mainContainer.classList.add('floating');
  }else{
    console.log("OK")
    
  }
});
